import H from '@here/maps-api-for-javascript/bin/mapsjs.bundle.harp'
import { config } from 'lib/config'

// Modules singleton instance form Platform
let platform: H.service.Platform | undefined = undefined
const { APP_KEY: apikey } = config

export const createPlatform = (key = apikey): H.service.Platform => {
  if (platform !== undefined) {
    return platform
  }

  platform = new H.service.Platform({ apikey: key })

  return platform
}
